import type { ModelLead } from '@app/api/Leads/types';
import { formatLeadListTime } from '@app/components/LeadCard/utils/formatLeadListTime';
import { NO_NAME_LABEL } from '@app/constants';

export interface LeadListItemViewModel {
  id: number;
  displayName: string;
  avatarBase64: string | null;
  lastMessage: string;
  time: string;
  isUnread: boolean;
  isNoAnswer: boolean;
}

// Без права «Просмотр контактных данных клиентов» аккаунт и телефон клиента
// не заменяют пустое имя (issue/11538).
const getDisplayName = (lead: ModelLead, canShowContacts: boolean): string =>
  canShowContacts
    ? lead.ClientName ??
      lead.ClientAccountName ??
      lead.ClientPhone ??
      NO_NAME_LABEL
    : lead.ClientName || NO_NAME_LABEL;

const getLastMessage = (lead: ModelLead): string => {
  if (lead.LastMessage) return lead.LastMessage;
  if (lead.IsNoCommunication) return 'Коммуникаций ещё не было';

  return 'Нет сообщений';
};

export const getLeadListItemViewModel = (
  lead: ModelLead,
  canShowContacts: boolean
): LeadListItemViewModel => ({
  id: lead.Id,
  displayName: getDisplayName(lead, canShowContacts),
  avatarBase64: lead.ClientPhoto,
  lastMessage: getLastMessage(lead),
  time: formatLeadListTime(lead.LastUpdate ?? lead.CreateTime),
  isUnread: Boolean(lead.UnreadMessage),
  isNoAnswer: lead.IsNoAnswer,
});
